export const dark = {
  components: {
    Table: {
      colorBgContainer: "#202020",
      colorText: "#BBBBBB",
      headerColor: "#BBBBBB",
      borderColor: "#3A3A3A",
      headerSplitColor: "#3A3A3A",
      rowHoverBg: "#333333",
      colorBorder: "#3A3A3A",
    },
    Layout: {
      bodyBg: "#181818",
    },
    Input: {
      colorBgContainer: "#2A2A2A",
      colorBgContainerDisabled: "#2A2A2A",
      colorText: "#BBBBBB",
      colorTextPlaceholder: "#BBBBBB",
      colorBorder: "#3A3A3A",
      colorFillSecondary: "rgba(0, 0, 0, 0.02)",
      activeBorderColor: "#3A3A3A",
      activeShadow: "#3A3A3A",
      hoverBorderColor: "#3A3A3A",
    },
    Select: {
      colorBgContainer: "#2A2A2A",
      colorText: "#BBBBBB",
      colorTextPlaceholder: "#BBBBBB",
      colorBorder: "rgba(150, 150, 150, 0.493)",
      colorPrimaryHover: "rgba(249, 158, 44, 1)",
      colorIconHover: "#BBB",
      optionSelectedBg: "#2A2A2A",
      colorBgElevated: "#333",
      controlOutline: "none",
      optionActiveBg: "#333333",
      colorTextQuaternary: "#3A3A3A",
    },
    Button: {
      colorBorderSecondary: "rgba(249, 158, 44, 1)",
      colorPrimary: "rgba(249, 158, 44, 1)",
      colorPrimaryHover: "#BBBBBB",
      colorIcon: "rgba(249, 158, 44, 1)",
      colorIconHover: "rgba(249, 158, 44, 1)",
      primaryShadow: "none",
      dangerShadow: "none",
      colorTextDisabled: "#AAAAAA",
      borderColorDisabled: "#3A3A3A",
    },
    //   Form: {
    //     labelColor: "#BBBBBB",
    //   },
    Tabs: {
      itemColor: "#BBBBBB",
      itemHoverColor: "#FFFFFF",
      itemSelectedColor: "rgba(249, 158, 44, 1)",
      colorPrimaryActive: "rgba(249, 158, 44, 1)",
      inkBarColor: "rgba(249, 158, 44, 1)",
    },
    Modal: {
      contentBg: "#3A3A3A",
      headerBg: "#3A3A3A",
      titleColor: "#FFFFFF",
      colorText: "#BBBBBB",
      colorBgTextActive: "#BBBBBB",
      colorBgTextHover: "#BBBBBB",
    },
    Menu: {
      darkItemSelectedBg: "#3A3A3A",
      colorBgContainer: "#fff",
    },
    Switch: {
      colorPrimary: "#565656",
      colorPrimaryHover: "#737373",
    },
    Radio: {
      colorText: "#737373",
      colorBorder: "#3A3A3A",
      colorPrimaryActive: "#BBBBBB",
      buttonCheckedBg: "rgba(249, 158, 44, 1)",
      colorPrimaryHover: "#737373",
      colorPrimary: "#565656",
    },
    Dropdown: {
      colorBgContainer: "#3A3A3A",
      colorText: "#BBBBBB",
      colorPrimaryHover: "#565656",
      colorPrimary: "#333333",
    },
    DatePicker: {
      colorBgContainer: "#3A3A3A",
      colorBgElevated: "#3A3A3A",
      colorText: "#BBBBBB",
      colorTextPlaceholder: "#BBBBBB",
      colorIcon: "#fff",
      colorIconHover: "#fff",
      colorPrimary: "rgba(249, 158, 44, 1)",
      hoverBorderColor: "#BBBBBB",
    },
    Pagination: {
      itemActiveBg: "#3a3a3a",
      colorPrimary: "#bbb",
      colorPrimaryHover: "rgba(249, 158, 44, 1)",
      colorText: "#fff",
      colorTextDisabled: "#fff",
    },
    Drawer: {
      colorBgElevated: "#262626", // Drawer foni
      colorText: "#ffffff", // Matn rangi
      colorPrimary: "#f99e2c", // Asosiy tugma rangi
      colorPrimaryHover: "#ffb347", // Tugmalar hover rangi
      paddingLG: 24, // Ichki padding
      borderRadiusLG: 10, // Burchaklarni yumshatish
      colorIcon: "#ffffff", // Close tugmasining rangi (✖)
      colorIconHover: "#ffb347",
    },
    Empty: {
      colorText: "rgba(249, 158, 44, 1)",
      colorTextDisabled: "rgba(249, 158, 44, 1)",
    },
  },
  token: {
    fontFamily: "Inter, sans-serif",
    colorText: "#bbb",
    borderRadius: 8,
    colorBgContainer: "#3a3a3a",
  },
};
export const light = {
  components: {
    Select: {
      colorTextPlaceholder: "rgba(155, 157, 170, 1)",
      colorPrimary: "rgba(249, 158, 44, 1)",
      colorPrimaryHover: "rgba(249, 158, 44, 1)",
    },
    Tabs: {
      inkBarColor: "rgba(249, 158, 44, 1)",
      itemSelectedColor: "rgba(24, 26, 41, 1)",
      itemHoverColor: "rgba(24, 26, 41, 1)",
    },
    Input: {
      hoverBorderColor: "rgba(249, 158, 44, 1)",
      activeBorderColor: "rgba(249, 158, 44, 1)",
      colorTextPlaceholder: "rgba(155, 157, 170, 1)",
    },
    Upload: {
      colorPrimaryHover: "rgba(249, 158, 44, 1)",
    },
    Button: {
      colorPrimary: "rgba(249, 158, 44, 1)",
      colorPrimaryHover: "rgba(249, 158, 44, 1)",
    },
    Textarea: {
      colorBorder: "0px 1px 3px 0px rgba(20, 22, 41, 0.1)",
    },
    Menu: {
      darkItemSelectedBg: "rgba(255, 255, 255, 0.08)",
    },
    Pagination: {
      colorPrimary: "#262626",
      colorPrimaryHover: "rgba(249, 158, 44, 1)",
      colorBorder: "#000",
    },
  },
  token: {
    fontFamily: "Inter, sans-serif",
    color: "#262626",
    colorBgContainer: "#fff",
    borderRadius: 8,
  },
};
